import { cn } from '#app/utils/misc.tsx'

export function SkillDescription({
	html,
	className,
}: {
	html: string | null | undefined
	className?: string
}) {
	if (!html) return null
	return (
		<div
			className={cn('skill-prose', className)}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	)
}
